{
  "LABEL_MGMT": {
    "HEADER": "Etichette",
    "HEADER_BTN_TXT": "Aggiungi etichetta",
    "LOADING": "Recupero etichette",
    "DESCRIPTION": "Labels help you categorize and prioritize conversations and leads. You can assign a label to a conversation or contact using the side panel.",
    "LEARN_MORE": "Learn more about labels",
    "SEARCH_404": "Non ci sono elementi che corrispondono a questa richiesta",
    "LIST": {
      "404": "Non ci sono etichette disponibili in questo account.",
      "TITLE": "Gestisci etichette",
      "DESC": "Le etichette consentono di raggruppare le conversazioni insieme.",
      "TABLE_HEADER": {
        "NAME": "Nome",
        "DESCRIPTION": "Descrizione",
        "COLOR": "Colore"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nome etichetta",
        "PLACEHOLDER": "Nome etichetta",
        "REQUIRED_ERROR": "Nome etichetta obbligatorio",
        "MINIMUM_LENGTH_ERROR": "È richiesta una lunghezza minima di 2",
        "VALID_ERROR": "Sono ammessi solo lettere, numeri, trattino e sottolineatura"
      },
      "DESCRIPTION": {
        "LABEL": "Descrizione",
        "PLACEHOLDER": "Descrizione etichetta"
      },
      "COLOR": {
        "LABEL": "Colore"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Mostra etichetta nella barra laterale"
      },
      "EDIT": "Modifica",
      "CREATE": "Crea",
      "DELETE": "Elimina",
      "CANCEL": "Annulla"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Add label to conversation",
        "MULTIPLE_SUGGESTION": "Select this label",
        "DESELECT": "Deselect label",
        "DISMISS": "Dismiss suggestion"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Dismiss",
      "ADD_SELECTED_LABELS": "Add selected labels",
      "ADD_SELECTED_LABEL": "Add selected label",
      "ADD_ALL_LABELS": "Add all labels",
      "SUGGESTED_LABELS": "Suggested labels"
    },
    "ADD": {
      "TITLE": "Aggiungi etichetta",
      "DESC": "Le etichette consentono di raggruppare le conversazioni insieme.",
      "API": {
        "SUCCESS_MESSAGE": "Etichetta aggiunta correttamente",
        "ERROR_MESSAGE": "Si è verificato un errore, riprova"
      }
    },
    "EDIT": {
      "TITLE": "Modifica etichetta",
      "API": {
        "SUCCESS_MESSAGE": "Campagna aggiornata con successo",
        "ERROR_MESSAGE": "Si è verificato un errore, riprova"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Elimina",
      "API": {
        "SUCCESS_MESSAGE": "Etichetta eliminata con successo",
        "ERROR_MESSAGE": "Si è verificato un errore, riprova",
        "IN_USE_ERROR": "Questa etichetta non può essere eliminata perché è utilizzata in {usages}. Rimuovila prima da questi elementi.",
        "IN_USE_FILTERS": "filtri: {names}",
        "IN_USE_AUTOMATIONS": "regole di automazione: {names}",
        "IN_USE_MACROS": "macro: {names}"
      },
      "CONFIRM": {
        "TITLE": "Conferma eliminazione",
        "MESSAGE": "Sei sicuro di voler eliminare ",
        "YES": "Sì, elimina ",
        "NO": "No, conserva "
      }
    }
  }
}
